// extracted by mini-css-extract-plugin
export var container = "blogArticleCard-module--container--3UrXf";
export var descriptionParagraph = "blogArticleCard-module--description-paragraph--1ki5D";
export var imageContainer = "blogArticleCard-module--image-container--2PX6x";
export var textContainer = "blogArticleCard-module--text-container--1r-mA";